import { TFunction } from 'i18next';

export interface ClientBalanceStatusConfig {
  getLabel: (t: TFunction) => string;
  code: string;
  color: string;
}

export const clientBalancesStatusConfig = {
  done: {
    getLabel: (t: TFunction) => t('done'),
    code: '0',

    color: '#00D39D',
  },

  active: {
    getLabel: (t: TFunction) => t('active'),
    code: '1',

    color: '#3503fc',
  },

  attached: {
    getLabel: (t: TFunction) => t('attached'),
    code: '2',

    color: '#FC8A05',
  },
};

export const clientBalancesConfigByCode = Object.fromEntries(
  Object.values(clientBalancesStatusConfig).map((config) => [config.code, config]),
) as Record<string, ClientBalanceStatusConfig>;
